module.exports = __webpack_public_path__ + "static/media/slapballs.6804b0c3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/slapballs.wav
// module id = 516
// module chunks = 0